import React, { Component } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import TextField from 'react-md/lib/TextFields';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { Link } from 'react-router-dom';
import Recaptcha from 'react-google-recaptcha';

import './OfferForm.css';

const RECAPTCHA_KEY = '6Le9TlwUAAAAANmO2Rf-jvcn8xZ2OLCsvN27evxG';

const encode = (data) => {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&");
}

class OfferForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      subject: 'Farang ' + (this.props.intl.locale ==="fi"?'Premium Catering tarjouspyyntö':'Premium Catering request'),
	  language: this.props.intl.locale,
      name: '',
      company: '',
      email: '',
      phone: '',
      date: '',
      time: '',
      location: '',
      people: '',
      event: '',
      // restaurant: [],
      description: '',
      dishes: '',
      service: [],
      budget: '',
      success: false,
      error: false,
    }
  }

  handleChange(field, value) {
    this.setState({
      [field]: value
    });
  }
  
  handleRecaptcha(value) {
    this.setState({ "g-recaptcha-response": value });
  };

  handleCheckbox(name, checkbox) {
    let array;

    if(name === 'restaurant') {
      array = this.state.restaurant;
    }
    if(name === 'service') {
      array = this.state.service;
    }

    if(array.indexOf(checkbox) === -1) {
      array.push(checkbox);
    }
    else {
      let index = array.indexOf(checkbox);
      array.splice(index, 1);
    }

    this.setState({
      [name]: array
    });
  }

  handleSubmit(e) {
    e.preventDefault();

    if(this.state.name && this.state.email && this.state.phone && this.state.date && this.state.people && this.state.budget) {
      fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: encode({ "form-name": "offer", ...this.state })
      })
      .then(() => this.setState({ success: true, error: false }))
      .catch(error => this.setState({ success: false, error: true }))
    }
    else {
      this.setState({ error: true })
    }
  }

  

  render() {
    let options = [
      { value: 'cocktail', label: this.props.intl.messages["offerForm.serviceTypeCocktail"] },
      { value: 'buffet', label: this.props.intl.messages["offerForm.serviceTypeBuffet"] },
      { value: 'dinner', label: this.props.intl.messages["offerForm.serviceTypeDinner"] }
    ];

    let fiLocale = require('moment/locale/fi');
    moment.locale('fi', fiLocale);

    return (
      <div id="offer" className="offer">
        <header>
          
          <h3>{this.props.intl.messages["offerForm.heading"]}</h3>
          <p>{this.props.intl.messages["offerForm.description"]}</p>
        </header>
        { !this.state.success &&
          <form onSubmit={this.handleSubmit.bind(this)} data-netlify-recaptcha="true">
            <input type="hidden" name="form-name" value="offer" />
            <input type="hidden" name="bot-field" value="" />
            <fieldset>
              <div>
                <TextField id="name" label={this.props.intl.messages["offerForm.name"]} onChange={(e) => this.handleChange('name', e)} required />
              </div>
              <div>
                <TextField id="company" label={this.props.intl.messages["offerForm.company"]} onChange={(e) => this.handleChange('company', e)} />
              </div>
              <div>
                <TextField id="email" type="email" label={this.props.intl.messages["offerForm.email"]} onChange={(e) => this.handleChange('email', e)} required />
              </div>
              <div>
                <TextField id="phone" type="tel" label={this.props.intl.messages["offerForm.phone"]} onChange={(e) => this.handleChange('phone', e)} required />
              </div>
              <div>
                <div className="halfwidth">
                  {this.state.date && <div className="datepicker-wrapper"><label htmlFor="date" className="md-floating-label md-floating-label--floating">{this.props.intl.messages["offerForm.date"]} *</label></div>}
                  <DatePicker locale="fi" placeholderText={`${this.props.intl.messages["offerForm.date"]} *`} selected={this.state.date} onChange={(e) => this.setState({date: e})} minDate={moment()} maxDate={moment().add(365, "days")} />
                </div>
                <TextField id="time" className="halfwidth" label={this.props.intl.messages["offerForm.time"]} onChange={(e) => this.handleChange('time', e)} />
              </div>
              <div>
                <TextField id="location" label={this.props.intl.messages["offerForm.location"]} onChange={(e) => this.handleChange('location', e)} />
              </div>
              <div>
                <div className="select-wrapper">
                  {this.state.serviceType && <label htmlFor="serviceType" className="md-floating-label md-floating-label--floating">{this.props.intl.messages["offerForm.serviceType"]} *</label>}
                  <Select
                    name="form-field-name"
                    clearable={false}
                    searchable={false}
                    openOnFocus={true}
                    placeholder={this.props.intl.messages["offerForm.serviceType"]}
                    value={this.state.serviceType}
                    options={options}
                    onChange={(e) => this.setState({serviceType: e.value})}
                  />
                </div>
              </div>
              <div>
                <TextField id="eventType" type="tel" label={this.props.intl.messages["offerForm.eventType"]} onChange={(e) => this.handleChange('eventType', e)} />
              </div>
              <div>
                <TextField id="people" className="halfwidth" label={this.props.intl.messages["offerForm.people"]} onChange={(e) => this.handleChange('people', e)} required />
              </div>
            </fieldset>
            {/*
            <fieldset className="checkbox">
              <legend>Ravintolan makumaailma</legend>
              <label className="control checkbox">Farang
                <input type="checkbox" name="restaurant" value="farang" onChange={(e) => this.handleCheckbox('restaurant', e.currentTarget.value)} />
                <div className="indicator" />
              </label>
              <label className="control checkbox">Gaijin
                <input type="checkbox" name="restaurant" value="gaijin" onChange={(e) => this.handleCheckbox('restaurant', e.currentTarget.value)} />
                <div className="indicator" />
              </label>
              <label className="control checkbox">Boulevard Social
                <input type="checkbox" name="restaurant" value="boulevardsocial" onChange={(e) => this.handleCheckbox('restaurant', e.currentTarget.value)} />
                <div className="indicator" />
              </label>
              <label className="control checkbox">Bronda
                <input type="checkbox" name="restaurant" value="bronda" onChange={(e) => this.handleCheckbox('restaurant', e.currentTarget.value)} />
                <div className="indicator" />
              </label>
              <label className="control checkbox">Levain
                <input type="checkbox" name="restaurant" value="levain" onChange={(e) => this.handleCheckbox('restaurant', e.currentTarget.value)} />
                <div className="indicator" />
              </label>
            </fieldset>
            */}
            <fieldset>
              <legend>{this.props.intl.messages["offerForm.premisesHeading"]}</legend>
              <p>{this.props.intl.messages["offerForm.premisesDescription"]}</p>

              <TextField id="description" rows={3} onChange={(e) => this.handleChange('description', e)} />

            </fieldset>
            <fieldset className="radio">
              <legend>{this.props.intl.messages["offerForm.dishesHeading"]}</legend>
              <label className="control radio">{this.props.intl.messages["offerForm.dishesYes"]}
                <input type="radio" name="dishes" value="yes" checked={this.state.dishes === 'yes'} onChange={(e) => this.handleChange('dishes', e.currentTarget.value)} />
                <div className="indicator" />
              </label>
              <label className="control radio">{this.props.intl.messages["offerForm.dishesNo"]}
                <input type="radio" name="dishes" value="no" checked={this.state.dishes === 'no'} onChange={(e) => this.handleChange('dishes', e.currentTarget.value)} />
                <div className="indicator" />
              </label>
            </fieldset>
            <fieldset className="checkbox">
              <legend>{this.props.intl.messages["offerForm.activityHeading"]}</legend>
              <p>{this.props.intl.messages["offerForm.activityDescription"]} <Link to='/ohjelmapalvelut'>{this.props.intl.locale === 'fi' ? 'täällä' : 'here'}</Link>.</p>
              <label className="control checkbox">{this.props.intl.messages["offerForm.activityCocktailSchool"]}
                <input type="checkbox" name="service" value="cocktail" onChange={(e) => this.handleCheckbox('service', e.currentTarget.value)} />
                <div className="indicator" />
              </label>
              <label className="control checkbox">{this.props.intl.messages["offerForm.activitySakeTasting"]}
                <input type="checkbox" name="service" value="saketasting" onChange={(e) => this.handleCheckbox('service', e.currentTarget.value)} />
                <div className="indicator" />
              </label>
              <label className="control checkbox">{this.props.intl.messages["offerForm.activityWineTasting"]}
                <input type="checkbox" name="service" value="winetasting" onChange={(e) => this.handleCheckbox('service', e.currentTarget.value)} />
                <div className="indicator" />
              </label>
              <div>
                <TextField id="budget" className="halfwidth" label={this.props.intl.messages["offerForm.budget"]} onChange={(e) => this.handleChange('budget', e)} required />
              </div>
            </fieldset>
            <br/>
            <Recaptcha
              ref="recaptcha"
              sitekey={RECAPTCHA_KEY}
              onChange={(val) => this.handleRecaptcha(val)}
              theme="dark"
            />
            <br/>            
            <button disabled={!this.state['g-recaptcha-response']} className="btn" type="submit">{this.props.intl.messages["offerForm.submit"]}</button>

          </form>
        }
        { !this.state.success && this.state.error &&
          <p className="fail">
            {this.props.intl.messages["offerForm.fail"]}
          </p>
        }
        {
          this.state.success &&
          <p className="success">
            {this.props.intl.messages["offerForm.success"]}
          </p>
        }
      </div>
    )
  }
}

OfferForm.propTypes = {
  intl: intlShape.isRequired,
}

export default injectIntl(OfferForm)



// WEBPACK FOOTER //
// ./src/components/OfferForm.js